import React, { useState } from 'react';
import { Paper, Box, Typography, Button, TextField, Grid, useTheme, Divider } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from '../HeaderUi/Header';
import Footer from '../HomeChat/Footer.jsx';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Fade from 'react-reveal/Fade';
import axios from 'axios';
import Zoom from 'react-reveal/Zoom';
import * as Styles from '../../Common/Styles.js';
// import * as Styles from '../../Common/Styles.js';
const ContactUs = () => {
  const theme = useTheme();
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    message: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.fullName || !formData.email || !formData.message) {
      toast.error('Please fill in all required fields');
      return;
    }

    try {
      await axios.post('/api/contact', formData);
      toast.success('Your message has been sent successfully');
      setFormData({ fullName: '', email: '', message: '' });
    } catch (error) {
      toast.error('Submission failed. Please try again.');
    }
  };

  return (
    <>
      {/* <ToastContainer position="bottom-right" /> */}
      <Paper elevation={0} sx={{ background: '#ffffff' }}>
        <Box
          sx={{
            position: 'relative',
            height: '30vh',
            background: '#F5F5F7',
          }}
        >
          <Box
            sx={{
              zIndex: 1,
              width: '100%',
              position: 'absolute',
            }}
          >
            <Header />
            <Fade top duration={1000}>
              <Typography sx={{ ...Styles.headHeading, mt: 12 }}>
                Contact Us
              </Typography>
            </Fade>

          </Box>
        </Box>

        {/* Contact Content */}
        <Box sx={{
          maxWidth: '1200px',
          mx: 'auto',
          px: 4,
          py: 8
        }}>
          <Grid container spacing={8}>
            {/* Contact Information */}
            <Grid item md={5}>
              <Fade left duration={1000}>
                <Box sx={{
                  position: 'sticky',
                  top: '100px',
                  pr: 4
                }}>
                  <Box sx={{ mb: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                      <LocationOnIcon sx={{
                        color: theme.palette.text.secondary,
                        mr: 2,
                        mt: '2px',
                        fontSize: '1.5rem'
                      }} />
                      <Box>
                        <Typography variant="subtitle1" sx={{
                          fontWeight: 600,
                          mb: 0.5,
                          color: theme.palette.text.primary
                        }}>
                          Registered Office
                        </Typography>
                        <Typography variant="body2" sx={{
                          color: theme.palette.text.secondary,
                          lineHeight: 1.6
                        }}>
                          Unada LexiLegal AI India Private Limited<br />
                          550, Iscon Emporio, Jodhpur Char Rasta<br />
                          Ahmedabad - 380015<br />
                          Gujarat, India
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Divider sx={{ my: 4 }} />

                  <Box sx={{ mb: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <PhoneIcon sx={{
                        color: theme.palette.text.secondary,
                        mr: 2,
                        fontSize: '1.5rem'
                      }} />
                      <Box>
                        <Typography variant="subtitle1" sx={{
                          fontWeight: 600,
                          color: theme.palette.text.primary
                        }}>
                          Direct Line
                        </Typography>
                        <Typography variant="body2" sx={{
                          color: theme.palette.text.secondary
                        }}>
                          +91 8780961035
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Box sx={{ mb: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <EmailIcon sx={{
                        color: theme.palette.text.secondary,
                        mr: 2,
                        fontSize: '1.5rem'
                      }} />
                      <Box>
                        <Typography variant="subtitle1" sx={{
                          fontWeight: 600,
                          color: theme.palette.text.primary
                        }}>
                          Business Inquiries
                        </Typography>
                        <Typography variant="body2" sx={{
                          color: theme.palette.text.secondary
                        }}>
                          <a href="mailto:business@parasors.in" style={{ color: theme.palette.text.secondary, textDecoration: 'none' }}>
                            business@parasors.in
                          </a>
                        </Typography>
                      </Box>

                    </Box>
                  </Box>

                  <Box sx={{
                    background: '#f8f9fa',
                    borderRadius: 2,
                    p: 3,
                    mt: 4
                  }}>
                    <Typography variant="body2" sx={{
                      color: theme.palette.text.secondary,
                      fontSize: '0.9rem',
                      lineHeight: 1.6
                    }}>
                      <Box component="span" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
                        Office Hours:
                      </Box><br />
                      Monday - Friday: 9:00 AM - 6:00 PM IST<br />
                      Saturday: By appointment only<br />
                      Sunday: Closed
                    </Typography>
                  </Box>
                </Box>
              </Fade>
            </Grid>

            {/* Contact Form */}
            <Grid item md={7}>
              <Fade right duration={1000}>
                <Box sx={{
                  background: '#ffffff',
                  borderRadius: '12px',
                  p: 5,
                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                  border: '1px solid rgba(0,0,0,0.08)'
                }}>
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Full Name"
                          variant="outlined"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleInputChange}
                          required
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                              '& fieldset': {
                                borderColor: 'rgba(0,0,0,0.1)',
                                borderWidth: '1px'
                              },
                            }
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Email Address"
                          type="email"
                          variant="outlined"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                            }
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Message"
                          variant="outlined"
                          multiline
                          rows={6}
                          name="message"
                          value={formData.message}
                          onChange={handleInputChange}
                          required
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                            }
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          sx={{
                            py: 1.5,
                            borderRadius: '8px',
                            textTransform: 'none',
                            fontSize: '1rem',
                            fontWeight: 600,
                            backgroundColor: '#091A32',
                            '&:hover': {
                              backgroundColor: '#0d274a',
                              boxShadow: 'none'
                            }
                          }}
                        >
                          Send Message
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </Box>
              </Fade>
            </Grid>
          </Grid>

          {/* Map Section */}
          <Box sx={{
            mt: 8,
            borderRadius: '12px',
            overflow: 'hidden',
            border: '1px solid rgba(0,0,0,0.08)'
          }}>
            <iframe
              title="Corporate Location"
              width="100%"
              height="400"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://maps.google.com/maps?q=Unada%20Labs%20Pvt%20Ltd,%20Jodhpur%20Char%20Rasta,%20Satellite,%20Ahmedabad,%20Gujarat,%20India&t=&z=15&ie=UTF8&iwloc=&output=embed"
              style={{ border: 0 }}
            />
          </Box>
        </Box>
      </Paper>
      <Footer />
    </>
  );
};

export default ContactUs;